<script lang="ts">
// Import these in Modal components for re-use
export const modalProps = {
  title: {
    type: String,
  },

  closeModal: {
    type: Function,
    default: () => {},
  },
}
</script>

<script setup lang="ts">
const props = defineProps({ ...modalProps })
</script>

<template>
  <div
    class="relative z-10"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
    <div
      class="fixed inset-0 bg-gray-500/75 transition-opacity"
      aria-hidden="true"
    ></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
        <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <slot
            name="header"
            :closeModal="props.closeModal"
          >
            {{ props.title }}
          </slot>

          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <slot :closeModal="props.closeModal" />
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <slot
              name="footer"
              :closeModal="props.closeModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
